import { render, staticRenderFns } from "./twitterSearchSetting.vue?vue&type=template&id=28bc5dbb&"
import script from "./twitterSearchSetting.vue?vue&type=script&lang=js&"
export * from "./twitterSearchSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports